import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row,Col,Card,Placeholder, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const SocietyClubs = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Pages,setPages]=useState([]);
    useEffect(()=>
    {
        const SocietyClubPages = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/subMenu/29");
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sp_id + "/spImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sp_id + "/spImageHi")
                                .then(upph => upph.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp,upph]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upph
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].spImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].spImageHi = (el.upph.length > 0) ? global.config.uploadPath + el.upph[0].up_fname + el.upph[0].up_ext : '';                            
                        });
                        setPages(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('SocietyClubPages Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setPages([]);
                    setLoading(false);            
                }
                if( global.config.IsPrint === true ) { console.info('SocietyClubPages : Result',result); }
            } catch (error) 
            {
                console.error('SocietyClubPages : Error', error.message);
                setLoading(false);
            }
        };
        SocietyClubPages();
    },[])
    return (
        <React.Fragment>
        {isLoading ? (
            <Row className='row-cols-3 g-3'>
            {[...Array(10)].map((_,index)=>(
                <Col key={index}>
                    <Card className="text-center shadow h-100" data-aos="flip-up" data-aos-duration="1000">
                        <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                        <Card.Body>
                            <Card.Title><Placeholder xs={10} /></Card.Title>
                            <Button className='btn btn-info w-50'><Placeholder xs={12} /></Button>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
            </Row>
            ) : (
            <Row className='row-cols-3 g-3'>
                <Col className='d-none'>
                    <Card className="text-center shadow" data-aos="flip-up" data-aos-duration="1000">
                        <Card.Img src={global.config.uploadPath+'671782282.png'} />
                        <Card.Body>
                            <Card.Title>Societies at IGDTUW</Card.Title>
                            <a href={global.config.uploadPath+'175833346.pdf'} className='btn btn-info'>Read More</a>
                        </Card.Body>
                    </Card>
                </Col>
                {Pages.map((sp,index)=>(
                <Col key={index}>
                    <Card className="text-center shadow" data-aos="flip-up" data-aos-duration="1000">
                        {appLanguage === 'hi' ? 
                            (
                                sp.spImageHi 
                                ? <Card.Img src={sp.spImageHi} /> 
                                : sp.spImage
                                    ? <Card.Img src={sp.spImage} /> 
                                    : <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                            ) : (
                                sp.spImage 
                                ? <Card.Img src={sp.spImage} /> 
                                : <Placeholder xs={12} className="card-img-top" style={{minHeight:"150px"}} />
                            )
                        }
                        <Card.Body>
                            <Card.Title>{appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name}</Card.Title>
                            <NavLink to={`${sp.parentMenu.parentMenu.sp_htaccess}/${sp.parentMenu.sp_htaccess}/${sp.sp_htaccess}`} className='btn btn-info'>
                                {t('ReadMore')}
                            </NavLink>
                        </Card.Body>
                    </Card>
                </Col>
                ))}
            </Row>
        )}
        </React.Fragment>
    );
}
export default SocietyClubs;